// Service.model.ts

import { FileMedia, IFileMedia } from "./file-media.model";

export interface IService {
  // serviceId: string;
  neighborhoodId: string;
  service: string;
  // fileId?: string;
  descriptionRequired: boolean;
  status: boolean;
  image?: IFileMedia;
}

export class Service {
  service: string;
  fileId?: string;
  descriptionRequired: boolean;
  status: boolean;
  image?: FileMedia;

  constructor(data: IService) {
    // this.serviceId = data.serviceId;
    // this.neighborhoodId = data.neighborhoodId;
    this.service = data.service;
    // this.fileId = data.fileId;
    this.descriptionRequired = data.descriptionRequired;
    this.status = data.status;
    this.image = data.image 
      ? new FileMedia(data.image) 
      : undefined;
  }
}
